import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Subject, takeUntil } from 'rxjs';
import { LoadingBarService } from './loading-bar.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'loading-bar',
  imports: [],
  templateUrl: './loading-bar.component.html',
  styleUrl: './loading-bar.component.scss',
  encapsulation: ViewEncapsulation.None,
  exportAs: 'loadingBar',
})
export class LoadingBarComponent implements OnChanges, OnInit, OnDestroy {
  @Input() autoMode: boolean = true;
  mode!: 'determinate' | 'indeterminate';
  progress: number | null = 0;
  show: boolean = false;
  private _unsubscribeAll: Subject<void> = new Subject<void>();

  constructor(
    private _loadingBarService: LoadingBarService,
    private _cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('autoMode' in changes) {
      this._loadingBarService.setAutoMode(coerceBooleanProperty(changes['autoMode'].currentValue));
    }
  }

  ngOnInit(): void {
    this._loadingBarService.mode$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      this.mode = value;
      this._cdr.markForCheck();
    });

    this._loadingBarService.progress$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      this.progress = value;
      this._cdr.markForCheck();
    });

    this._loadingBarService.show$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      setTimeout(() => {
        this.show = value;
        this._cdr.markForCheck();
      });
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
